import Toast from 'react-native-toast-message';

/**
 * Global toast utility — the one entry point for firing a toast. Success
 * dismisses quickly; errors linger so multi-sentence backend messages can be
 * read in full.
 */
export const showToast = (type: 'success' | 'error' | 'info', text1: string, text2?: string) => {
  Toast.show({
    type,
    text1,
    text2,
    // Success: short confirmation. Error/info: linger so multi-sentence backend
    // messages can be read in full.
    visibilityTime: type === 'success' ? 3000 : 4000,
    autoHide: true,
    topOffset: 60,
    // Allow up to 5 lines so long backend messages are never cut off.
    ...(text2 ? ({ text2NumberOfLines: 5 } as Record<string, unknown>) : {}),
  });
};
